import { type IReactionDisposer, makeAutoObservable, reaction } from 'mobx'
import { type Chatbot } from 'entities/Chatbot'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { SendFromStore } from 'widgets/SendFrom'

export class ChatbotNumberId {
  private readonly _disposeChatBot: IReactionDisposer | null = null
  private readonly _disposeSendFrom: IReactionDisposer | null = null

  store: SendFromStore

  constructor(private _chatbot: Chatbot, private _entities: IEntitiesStore) {
    makeAutoObservable(this)

    this.store = new SendFromStore(this._entities, {
      includeRCS: true,
      excludeDeprioritizedNumbers: true,
      getDropdownItemsOptions: {
        showOnlyVerifiedToolFree: true,
      },
      withDynamicSender: this._entities.featureFlagsStore.send_as_contact_owner,
    })

    this._disposeSendFrom = reaction(
      () => this.store.paramsSendFrom,
      (params) => params && this._chatbot.setSendFrom(params)
    )

    this._disposeChatBot = reaction(
      () => this._chatbot.sendFrom,
      (send_from) => this.store.setSendFrom(send_from)
    )
  }

  dispose = () => {
    this._disposeChatBot?.()
    this._disposeSendFrom?.()
  }
}
